import { render, staticRenderFns } from "./Default-menu.vue?vue&type=template&id=40f8ca96&scoped=true"
import script from "./Default-menu.vue?vue&type=script&lang=js"
export * from "./Default-menu.vue?vue&type=script&lang=js"
import style0 from "./Default-menu.vue?vue&type=style&index=0&id=40f8ca96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8ca96",
  null
  
)

export default component.exports